export class SportResumeInfo {
  _id: string;
  id: string;
  name: string;
  icon: string;
  image: string;
  tags: string[];
}
